export function generateSpiralPositions(
  positions: Float32Array,
  colors: Float32Array,
  particleCount: number
) {
  const arms = 4; // Number of spiral arms
  const armWidth = 0.3; // Width of each arm
  const revolutions = 3; // How many times the arms wrap around
  const randomness = 0.15; // Amount of random scatter
  const innerRadius = 0.5; // Minimum radius from center
  const bulgeSize = 2; // Size of the central galactic bulge
  const bulgeIntensity = 0.3; // Intensity of the central bulge

  for (let i = 0; i < particleCount; i++) {
    const i3 = i * 3;
    const progress = i / particleCount;
    
    // Determine if this particle is part of the central bulge
    const isBulge = Math.random() < (1 - progress) * bulgeIntensity;
    
    if (isBulge) {
      // Generate particles for the galactic bulge (center sphere)
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.random() * Math.PI * 2;
      const r = Math.pow(Math.random(), 0.5) * bulgeSize;
      
      positions[i3] = r * Math.sin(theta) * Math.cos(phi);
      positions[i3 + 1] = r * Math.sin(theta) * Math.sin(phi);
      positions[i3 + 2] = r * Math.cos(theta);
    } else {
      // Generate particles for the spiral arms
      const angle = progress * Math.PI * 2 * revolutions;
      const radius = innerRadius + (Math.pow(progress, 0.5) * 12);
      
      // Add spiral arm offset with varying width
      const armAngle = ((i % arms) / arms) * Math.PI * 2;
      const spiralAngle = angle + armAngle;
      const armOffset = Math.exp(-progress * 2) * armWidth;
      
      // Add randomness that increases with radius but varies by arm
      const randFactor = (radius / 13) * randomness * (1 + Math.sin(armAngle));
      const randX = (Math.random() - 0.5) * randFactor * radius;
      const randY = (Math.random() - 0.5) * randFactor * 0.5; // Less vertical spread
      const randZ = (Math.random() - 0.5) * randFactor * radius;
      
      // Add arm thickness variation
      const armR = radius + (Math.random() - 0.5) * armOffset * radius;
      
      positions[i3] = Math.cos(spiralAngle) * armR + randX;
      positions[i3 + 1] = randY;
      positions[i3 + 2] = Math.sin(spiralAngle) * armR + randZ;
    }
    
    // Enhanced color distribution
    const distanceFromCenter = Math.sqrt(
      Math.pow(positions[i3], 2) + 
      Math.pow(positions[i3 + 1], 2) + 
      Math.pow(positions[i3 + 2], 2)
    );
    
    // Core is brighter, edges fade more dramatically
    const intensity = Math.pow(Math.max(0, 1 - (distanceFromCenter / 15)), 1.5);
    const purpleVariation = Math.random() * 0.2; // Adds subtle color variation
    
    colors[i3] = (0.6 + purpleVariation) * intensity;     // R (purple-ish)
    colors[i3 + 1] = (0.2 + purpleVariation * 0.5) * intensity; // G
    colors[i3 + 2] = (0.8 + purpleVariation) * intensity; // B (more blue)
  }
}